// Central brand + SEO facts for BiteGoFood public pages. Single source of truth.
export const SITE = {
  name: "BiteGoFood",
  url: "https://bitego.org",
  tagline: "Food Near You, Faster Than Ever.",
  company: "Vijay Software Solutions Pvt Ltd",
  companyUrl: "https://www.vs-solutions.in/",
  companyAlt: ["VS-Solutions", "Vijay Software Solutions", "VS Solutions"],
  adsUrl: "https://ads-bitego.org/",
  brandAlt: ["BiteGo Food", "BiteGoFood App", "BiteGo"],
  founder: "Perikala Bhargav",
  email: "info@vs-solutions.org",
  logo: "https://bitego.org/bitego-icon.png",
  ogImage: "https://bitego.org/bitego-icon.png",
  description:
    "BiteGoFood is a food delivery platform by Vijay Software Solutions Pvt Ltd, connecting customers with restaurants and delivery partners. Discover food, order online and track deliveries.",
  locations: ["Hyderabad", "Andhra Pradesh"],
  // Official social profiles — intentionally empty until confirmed. Add exact URLs here
  // and they will flow into the footer and Organization "sameAs" structured data.
  social: [],
};

export const absUrl = (path = "/") => `${SITE.url}${path.startsWith("/") ? path : `/${path}`}`;

// Organization = the COMPANY (Vijay Software Solutions Pvt Ltd), with BiteGoFood as its brand/product.
export const orgSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.company,
  legalName: SITE.company,
  alternateName: SITE.companyAlt,
  url: SITE.companyUrl,
  logo: SITE.logo,
  email: SITE.email,
  description: `${SITE.company} is a technology company and the operator of BiteGoFood, a food delivery platform connecting customers, restaurants and delivery partners.`,
  founder: { "@type": "Person", name: SITE.founder },
  brand: { "@type": "Brand", name: SITE.name, url: SITE.url, logo: SITE.logo },
  owns: { "@type": "Product", name: SITE.name, url: SITE.url },
  contactPoint: {
    "@type": "ContactPoint",
    email: SITE.email,
    contactType: "customer support",
    areaServed: "IN",
    availableLanguage: ["English"],
  },
  ...(SITE.social.length ? { sameAs: SITE.social } : {}),
});

// WebSite = BiteGoFood (the product site). Preferred site name + legitimate brand aliases.
export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  alternateName: SITE.brandAlt,
  url: SITE.url,
  description: SITE.description,
  publisher: { "@type": "Organization", name: SITE.company, url: SITE.companyUrl },
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: `${SITE.url}/search?q={search_term_string}` },
    "query-input": "required name=search_term_string",
  },
});

export const softwareAppSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: SITE.name,
  applicationCategory: "FoodDeliveryApplication",
  operatingSystem: "Web, Android, iOS",
  url: SITE.url,
  description: SITE.description,
  offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
  publisher: { "@type": "Organization", name: SITE.company, url: SITE.companyUrl },
});

// Product entity for the dedicated /about/bitegofood page.
export const productSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: SITE.name,
  alternateName: SITE.brandAlt,
  url: `${SITE.url}/about/bitegofood`,
  logo: SITE.logo,
  image: SITE.ogImage,
  description: SITE.description,
  category: "Food Delivery Platform",
  brand: { "@type": "Brand", name: SITE.name },
  manufacturer: { "@type": "Organization", name: SITE.company, url: SITE.companyUrl, alternateName: SITE.companyAlt },
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: absUrl(it.path),
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
